export function trackMatomoSiteSearch({ keyword, url, title }) {
    const term = typeof keyword === 'string' ? keyword.trim() : '';
    if (!term) return;

    window._paq = window._paq || [];

    if (url) window._paq.push(['setCustomUrl', url]);
    if (title) window._paq.push(['setDocumentTitle', title]);

    window._paq.push(['trackSiteSearch', term]);
}